<template>
  <div class="debug-lint">
    <div class="position-relative">
      <textarea class="debug-lint-input" row="10" v-model="debugInput" />
      <div class="debug-button" @click="clipboard">复制</div>
      <div class="debug-button" style="left: 300px;" @click="goUrl">跳转</div>
    </div>
  </div>
</template>

<script>
import { clipboard } from '$common/utils/clipboard/clipboard';
export default {
  props: {
    debugInput: {
      type: String,
      default: () => ''
    }
  },
  methods: {
    clipboard() {
      clipboard({ copyString: this.debugInput, success: () => alert('copy success!') });
    },
    goUrl() {
      window.location.href = this.debugInput;
    }
  }
}
</script>

<style lang="stylus" scoped>
  .debug-lint {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1000
    width: 100%;
  }
  .debug-lint-input {
    position: absolute;
    top: 0;
    left: 0;
    padding: 0
    margin: 0;
    box-shadow: none;
    border: 0 none;
    width: 100%;
    font-size: 14px;
    height: 100px;
  }
  .debug-button {
    position: absolute;
    top: 110px;
    left: 0;
    width: 100px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    background-color: #000;
    color: #fff;
    border-radius: 10px;
    margin: 0 20px;
  }
</style>